import { useEffect, useState } from 'react';

import {
  getPendingNotificationProductIds,
  NOTIFICATION_INTENT_KEY,
  NOTIFICATION_INTENTS_CHANGED_EVENT
} from '~/utils/browser';

import useRootData from './useRootData';
import useUser from './useUser';

export default function useIsPendingConfirmation(
  productId: number,
  isNotified: boolean
) {
  const { newNotificationSignupFlowEnabled } = useRootData();
  const { isLoggedIn } = useUser();

  const [pendingProductIds, setPendingProductIds] = useState<number[]>([]);

  useEffect(() => {
    const syncPendingProductIds = () =>
      setPendingProductIds((prev) => {
        const next = getPendingNotificationProductIds();

        const isUnchanged =
          prev.length === next.length &&
          prev.every((id, index) => id === next[index]);

        return isUnchanged ? prev : next;
      });

    const syncOnStorageChange = (event: StorageEvent) => {
      if (event.key === null || event.key === NOTIFICATION_INTENT_KEY) {
        syncPendingProductIds();
      }
    };

    syncPendingProductIds();

    window.addEventListener(
      NOTIFICATION_INTENTS_CHANGED_EVENT,
      syncPendingProductIds
    );
    window.addEventListener('storage', syncOnStorageChange);

    return () => {
      window.removeEventListener(
        NOTIFICATION_INTENTS_CHANGED_EVENT,
        syncPendingProductIds
      );
      window.removeEventListener('storage', syncOnStorageChange);
    };
  }, []);

  return (
    newNotificationSignupFlowEnabled &&
    !isLoggedIn &&
    !isNotified &&
    pendingProductIds.includes(productId)
  );
}
